import { PopupPromiseController } from './popup-promise.controller';

const ngModule = angular.module('bb.popup-promise',[]);

ngModule.controller('popupPromiseController', PopupPromiseController);

export default ngModule;
